import React from "react";
import '../App.css';
import EducationCard from "../reusable-components/education-card";
import { Container, Grid, Typography, Box, Fade } from "@mui/material";
import { useLoaderData } from "react-router-dom";
import CertificationCard from "../reusable-components/certification-card";
import { School, WorkspacePremium } from '@mui/icons-material';

function Education() {
    const data = useLoaderData();

    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Fade in timeout={800}>
                <Box>
                    <Box sx={{ mb: 6 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <School color="primary" sx={{ fontSize: 40 }} />
                            <Typography variant="h3" component="h2" fontWeight="500">
                                Education Journey
                            </Typography>
                        </Box>
                        <Grid container spacing={3}>
                            {data.education && data.education.map((education) => (
                                <EducationCard key={education.degree} education={education} />
                            ))}
                        </Grid>
                    </Box>

                    <Box sx={{ mt: 8 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <WorkspacePremium color="primary" sx={{ fontSize: 40 }} />
                            <Typography variant="h3" component="h2" fontWeight="500">
                                Certifications
                            </Typography>
                        </Box>
                        <Grid container spacing={3}>
                            {data.certifications && data.certifications.map((certification) => (
                                <Grid item xs={12} sm={6} md={4} key={certification.name}>
                                    <CertificationCard certification={certification} />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
            </Fade>
        </Container>
    );
}

export default Education;